import { ResultCallback } from '../types/result-callback.type';

export function domReady(callback?: ResultCallback<Document>) {
  return new Promise<void>((resolve) => {
    if (
      document.readyState === 'interactive' ||
      document.readyState === 'complete'
    ) {
      if (callback !== undefined) callback(document);
      resolve();
    } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', () => {
        if (callback !== undefined) callback(document);
        resolve();
      });
    } else if ((document as any).attachEvent) {
      (document as any).attachEvent('onreadystatechange', function () {
        if (document.readyState != 'loading') {
          if (callback !== undefined) callback(document);
          resolve();
        }
      });
    }
  });
}
